import React from 'react'
import { useState, useEffect, useRef } from 'react';
import './ComponentsCss/AdminPageEdit.css';
// axios 
import axios from 'axios';
import useAuth from '../hooks/useAuth.js';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const AdminPageLawyerEdit = () => {
    const axiosPrivate = useAxiosPrivate();
    const [AllLawyerData, SetAllLawyerData] = useState();
    const [LawyerSel, SetLawyerSel] = useState(0);

    // add new data 
    const [lawyerId, SetlawyerId] = useState("");
    const [lawyerAccount, SetlawyerAccount] = useState("");
    const [lawyerAccountNum, SetlawyerAccountNum] = useState("");
    const [lawyerAsso, SetlawyerAsso] = useState("");
    const [lawyerBank, SetlawyerBank] = useState("");
    const [lawyerBankName, SetlawyerBankName] = useState("");
    const [lawyerEducation, SetlawyerEducation] = useState("");
    const [lawyerEmail, SetlawyerEmail] = useState("");
    const [lawyerExperience, SetlawyerExperience] = useState("");
    const [lawyerFax, SetlawyerFax] = useState("");
    const [lawyerFollowers, SetlawyerFollowers] = useState("");
    const [lawyerImage, SetlawyerImage] = useState("");
    const [lawyerImageBig, SetlawyerImageBig] = useState("");
    const [lawyerIntro, SetlawyerIntro] = useState("");
    const [lawyerName, SetlawyerName] = useState("");
    const [lawyerTel, SetlawyerTel] = useState("");

    const LawyerImageRef = useRef(null);
    const LawyerImageBigRef = useRef(null);

    const changeLawyerImageHandler = (event) => {
        //setAxiosNewsMainImage(file);
        SetlawyerImage(event.target.files[0].name);
    };
    const changeLawyerBigImageHandler = (event) => {
        //setAxiosNewsMainImage(file);
        SetlawyerImageBig(event.target.files[0].name);
    };
    function changeImageFnc(imgSel) {
        if (imgSel == 1) {
            LawyerImageRef.current.click();
        } else if (imgSel == 2) {
            LawyerImageBigRef.current.click();
        }
    }

    useEffect(() => {
        axiosAllLawyerData();
    }, []);
    const axiosAllLawyerData = async () => {
        console.log(" axiosAllLawyerData ");
        SetAllLawyerData("");
        var finalIP = "";
        // https://stepupkorea.kr/api/NewsList/getAllNews
        finalIP = "https://stepupkorea.kr/api/Lawyer/allLawyerData";
        try {
            const response = await axios.get(finalIP

            );
            if (response) {
                console.log(response.data);
                SetAllLawyerData(response.data);
                //SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }

    const axiosRegisterLawyer = async () => {

        try {
            /* 
                const { lawyerId, lawyerName, lawyerTel, lawyerFax, lawyerEmail,
           lawyerIntro, lawyerFollowers, lawyerEducation, lawyerExperience, lawyerAsso, lawyerImage
           , lawyerImageBig, lawyerBank, lawyerBankName } = req.body;
   
            */
            var registerDataJson = "";
            registerDataJson = JSON.stringify({
                laywerId: lawyerId,
                lawyerName: lawyerName,
                lawyerTel: lawyerTel,
                lawyerFax: lawyerFax,
                lawyerEmail: lawyerEmail,
                lawyerIntro: lawyerIntro,
                lawyerFollowers: lawyerFollowers,
                lawyerEducation: lawyerEducation,
                lawyerExperience: lawyerExperience,
                lawyerAsso: lawyerAsso,
                lawyerImage: lawyerImage,
                lawyerImageBig: lawyerImageBig,
                lawyerBank: lawyerBank,
                lawyerBankName: lawyerBankName

            }, null, 2);

            //console.log("AXIOS Registering Lawyer  : " + registerDataJson);
            var finalIP = "";
            // 	"/emergency/rssi/module-status-set/<ip>"
            finalIP = "https://stepupkorea.kr/api/admin/AddLawyer";
            //console.log(" axiosPostModuleStatus" + finalIP);
            const response = await axiosPrivate.post(finalIP,
                registerDataJson,
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,

                }
            );
            if (response) {
                console.log(" register lawyer success !");
                axiosAllLawyerData();
            }
        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Username and password are required.');

            } else if (err.response?.status === 401) {
                console.log('-- Wrong conf password ');

            }
            else if (err.response?.status === 402) {
                console.log('-- Username already exists ');

            } else {
                console.log('ERR');
            }

        }
    }
    const axiosUpdateLawyer = async () => {

        try {
            /* 
                const { lawyerId, lawyerName, lawyerTel, lawyerFax, lawyerEmail,
           lawyerIntro, lawyerFollowers, lawyerEducation, lawyerExperience, lawyerAsso, lawyerImage
           , lawyerImageBig, lawyerBank, lawyerBankName } = req.body;
   
            */
            var registerDataJson = "";
            registerDataJson = JSON.stringify({
                lawyerId: lawyerId,
                lawyerName: lawyerName,
                lawyerTel: lawyerTel,
                lawyerFax: lawyerFax,
                lawyerEmail: lawyerEmail,
                lawyerIntro: lawyerIntro,
                lawyerFollowers: lawyerFollowers,
                lawyerEducation: lawyerEducation,
                lawyerExperience: lawyerExperience,
                lawyerAsso: lawyerAsso,
                lawyerImage: lawyerImage,
                lawyerImageBig: lawyerImageBig,
                lawyerBank: lawyerBank,
                lawyerBankName: lawyerBankName

            }, null, 2);

            //console.log("AXIOS Registering Lawyer  : " + registerDataJson);
            var finalIP = "";
            // 	"/emergency/rssi/module-status-set/<ip>"
            finalIP = "https://stepupkorea.kr/api/admin/UpdateLawyer";
            //console.log(" axiosPostModuleStatus" + finalIP);
            const response = await axiosPrivate.post(finalIP,
                registerDataJson,
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,

                }
            );
            if (response) {
                console.log(" Update lawyer success !");
                axiosAllLawyerData();
            }
        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Username and password are required.');

            } else if (err.response?.status === 401) {
                console.log('-- Wrong conf password ');

            }
            else if (err.response?.status === 402) {
                console.log('-- Username already exists ');

            } else {
                console.log('ERR');
            }

        }
    }
    useEffect(() => {

        console.log("lawyer sel " + LawyerSel);
        if (LawyerSel == -1) {
            SetlawyerId("");
            SetlawyerAccount("");
            SetlawyerAccountNum("");
            SetlawyerAsso("");
            SetlawyerBank("");
            SetlawyerBankName("");
            SetlawyerEducation("");
            SetlawyerEmail("");
            SetlawyerExperience("");
            SetlawyerFax("");
            SetlawyerFollowers("");
            SetlawyerImage("");
            SetlawyerImageBig("");
            SetlawyerIntro("");
            SetlawyerName("");
            SetlawyerTel("");
        } else {
            if (AllLawyerData != null && AllLawyerData.length > 0) {
                SetlawyerId(AllLawyerData[LawyerSel]?.id);
                SetlawyerAccount(AllLawyerData[LawyerSel]?.lawyerAccount);
                SetlawyerAccountNum(AllLawyerData[LawyerSel]?.lawyerAccountNum);
                SetlawyerAsso(AllLawyerData[LawyerSel]?.lawyerAsso);
                SetlawyerBank(AllLawyerData[LawyerSel]?.lawyerBank);
                SetlawyerBankName(AllLawyerData[LawyerSel]?.lawyerBankName);
                SetlawyerEducation(AllLawyerData[LawyerSel]?.lawyerEducation);
                SetlawyerEmail(AllLawyerData[LawyerSel]?.lawyerEmail);
                SetlawyerExperience(AllLawyerData[LawyerSel]?.lawyerExperience);
                SetlawyerFax(AllLawyerData[LawyerSel]?.lawyerFax);
                SetlawyerFollowers(AllLawyerData[LawyerSel]?.lawyerFollowers);
                SetlawyerImage(AllLawyerData[LawyerSel]?.lawyerImage);
                SetlawyerImageBig(AllLawyerData[LawyerSel]?.lawyerImageBig);
                SetlawyerIntro(AllLawyerData[LawyerSel]?.lawyerIntro);
                SetlawyerName(AllLawyerData[LawyerSel]?.lawyerName);
                SetlawyerTel(AllLawyerData[LawyerSel]?.lawyerTel);
            }

        }
    }, [LawyerSel, AllLawyerData]);

    return (
        <div className='admin-page-edit-main'>
            <div className='admin-page-edit-list'>

                {
                    AllLawyerData != null && AllLawyerData.length > 0 ?
                        AllLawyerData.map((lawyer, index) => (
                            <div className='admin-page-list-button' onClick={() => SetLawyerSel(index)}>{lawyer.id} : {lawyer.lawyerName} </div>


                        ))
                        : null
                }
                <div className='admin-page-list-button' onClick={() => SetLawyerSel(-1)}> + 전문 회원 추가 </div>


            </div>
            <div className='admin-page-edit-details'>
                {
                    LawyerSel == -1 ?
                        <>
                            <div className='admin-page-title-text'> 이름: </div>
                            <input className='admin-page-input' value={lawyerName} onInput={(e) => SetlawyerName(e.target.value)} />

                            <div className='admin-page-title-text'> 번호: </div>
                            <input className='admin-page-input' value={lawyerTel} onInput={(e) => SetlawyerTel(e.target.value)} />

                            <div className='admin-page-title-text'> Fax: </div>
                            <input className='admin-page-input' value={lawyerFax} onInput={(e) => SetlawyerFax(e.target.value)} />
                            <div className='admin-page-title-text'> Email: </div>
                            <input className='admin-page-input' value={lawyerEmail} onInput={(e) => SetlawyerEmail(e.target.value)} />
                            <div className='admin-page-title-text'> 구독자수: </div>
                            <input className='admin-page-input' value={lawyerFollowers} onInput={(e) => SetlawyerFollowers(e.target.value)} />


                            <div className='admin-page-title-text'> 소개: </div>
                            <textarea className='admin-page-input' rows={8} cols={60} value={lawyerIntro} onInput={(e) => SetlawyerIntro(e.target.value)} />


                            <div className='admin-page-title-text'> 학력: </div>
                            <textarea className='admin-page-input' rows={8} cols={60} value={lawyerEducation} onInput={(e) => SetlawyerEducation(e.target.value)} />


                            <div className='admin-page-title-text'> 경력: </div>
                            <textarea className='admin-page-input' rows={8} cols={60} value={lawyerExperience} onInput={(e) => SetlawyerExperience(e.target.value)} />

                            <br />

                            <div className='admin-page-title-text'> 사진 파일 이름 (소): </div>

                            <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>
                            <input type="file" name="input1" ref={LawyerImageRef} style={{ display: 'none' }}
                                onChange={changeLawyerImageHandler} />
                            <input className='admin-page-input' value={lawyerImage} />


                            <div className='admin-page-title-text'> 사진 파일 이름 (대): </div>

                            <div className='admin-page-list-button' onClick={() => changeImageFnc(2)}> 파일 선택 </div>
                            <input type="file" name="input1" ref={LawyerImageBigRef} style={{ display: 'none' }}
                                onChange={changeLawyerBigImageHandler} />
                            <input className='admin-page-input' value={lawyerImageBig} />




                            <br />

                            <div className='admin-page-title-text'> 계좌번호: </div>
                            <input className='admin-page-input' value={lawyerAccount} onInput={(e) => SetlawyerAccount(e.target.value)} />
                            <div className='admin-page-title-text'> 계좌실명번호: </div>
                            <input className='admin-page-input' value={lawyerAccountNum} onInput={(e) => SetlawyerAccountNum(e.target.value)} />
                            <div className='admin-page-title-text'> 소속: </div>
                            <input className='admin-page-input' value={lawyerAsso} onInput={(e) => SetlawyerAsso(e.target.value)} />
                            <div className='admin-page-title-text'> 은행명: </div>
                            <input className='admin-page-input' value={lawyerBank} onInput={(e) => SetlawyerBank(e.target.value)} />
                            <div className='admin-page-title-text'> 예금주명: </div>
                            <input className='admin-page-input' value={lawyerBankName} onInput={(e) => SetlawyerBankName(e.target.value)} />

                            <br />
                            <br />
                            <div className='admin-page-list-button' onClick={() => axiosRegisterLawyer()}> 전문 회원 추가 + </div>

                            <br />
                            <br />

                        </>
                        :
                        AllLawyerData != null && AllLawyerData.length > 0 && LawyerSel != -1 ?
                            <>
                                <div className='admin-page-title-text'> ID:  {AllLawyerData[LawyerSel]?.id} </div>
                                <br />
                                <div className='admin-page-title-text'> 이름: </div>
                                <input className='admin-page-input' value={lawyerName} onInput={(e) => SetlawyerName(e.target.value)} />

                                <div className='admin-page-title-text'> 번호: </div>
                                <input className='admin-page-input' value={lawyerTel} onInput={(e) => SetlawyerTel(e.target.value)} />

                                <div className='admin-page-title-text'> Fax: </div>
                                <input className='admin-page-input' value={lawyerFax} onInput={(e) => SetlawyerFax(e.target.value)} />
                                <div className='admin-page-title-text'> Email: </div>
                                <input className='admin-page-input' value={lawyerEmail} onInput={(e) => SetlawyerEmail(e.target.value)} />
                                <div className='admin-page-title-text'> 구독자수: </div>
                                <input className='admin-page-input' value={lawyerFollowers} onInput={(e) => SetlawyerFollowers(e.target.value)} />


                                <div className='admin-page-title-text'> 소개: </div>
                                <textarea className='admin-page-input' rows={8} cols={60} value={lawyerIntro} onInput={(e) => SetlawyerIntro(e.target.value)} />


                                <div className='admin-page-title-text'> 학력: </div>
                                <textarea className='admin-page-input' rows={8} cols={60} value={lawyerEducation} onInput={(e) => SetlawyerEducation(e.target.value)} />


                                <div className='admin-page-title-text'> 경력: </div>
                                <textarea className='admin-page-input' rows={8} cols={60} value={lawyerExperience} onInput={(e) => SetlawyerExperience(e.target.value)} />

                                <br />

                                <div className='admin-page-title-text'> 사진 파일 이름 (소): </div>

                                <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>
                                <input type="file" name="input1" ref={LawyerImageRef} style={{ display: 'none' }}
                                    onChange={changeLawyerImageHandler} />
                                <input className='admin-page-input' value={lawyerImage} />


                                <div className='admin-page-title-text'> 사진 파일 이름 (대): </div>

                                <div className='admin-page-list-button' onClick={() => changeImageFnc(2)}> 파일 선택 </div>
                                <input type="file" name="input1" ref={LawyerImageBigRef} style={{ display: 'none' }}
                                    onChange={changeLawyerBigImageHandler} />
                                <input className='admin-page-input' value={lawyerImageBig} />


                                <br />

                                <div className='admin-page-title-text'> 계좌번호: </div>
                                <input className='admin-page-input' value={lawyerAccount} onInput={(e) => SetlawyerAccount(e.target.value)} />
                                <div className='admin-page-title-text'> 계좌실명번호: </div>
                                <input className='admin-page-input' value={lawyerAccountNum} onInput={(e) => SetlawyerAccountNum(e.target.value)} />
                                <div className='admin-page-title-text'> 소속: </div>
                                <input className='admin-page-input' value={lawyerAsso} onInput={(e) => SetlawyerAsso(e.target.value)} />
                                <div className='admin-page-title-text'> 은행명: </div>
                                <input className='admin-page-input' value={lawyerBank} onInput={(e) => SetlawyerBank(e.target.value)} />
                                <div className='admin-page-title-text'> 예금주명: </div>
                                <input className='admin-page-input' value={lawyerBankName} onInput={(e) => SetlawyerBankName(e.target.value)} />


                                <br />
                                <br />
                                <div className='admin-page-list-button' onClick={() => axiosUpdateLawyer()}> 정보 업데이트 </div>

                                <br />
                                <br />

                            </>
                            : null
                }

            </div>

        </div>
    )
}
/* 
lawyerAccount 계좌번호
lawyerAccountNum 계좌 실명번호 
lawyerAsso 소속 
lawyerBank 은행 
lawyerBankName 예금주명
lawyerEducation - 
lawyerEmail - 
lawyerExperience - 
lawyerFax - 
lawyerFollowers
lawyerId  - 
lawyerImage
lawyerImageBig
lawyerIntro - 
lawyerName - 
lawyerTel- 

*/

export default AdminPageLawyerEdit